<script setup>
import {useStore} from 'vuex'
import {computed} from "vue";

import CustomerShareModal from "./modals/CustomerShareModal.vue";
import DefaultButton from "../global/buttons/DefaultButton.vue";

const store = useStore();

const show = computed(() => store.getters["agencyMarketplace/showSharingModal"]);
const toggleModal = show =>  store.dispatch('agencyMarketplace/setShowSharingModal', show);
</script>

<template>
  <div>
    <DefaultButton
      size="md"
      class="w-100"
      @click="toggleModal(true)"
    >
      <i class="fas fa-share-alt xs-mr-5" />
      Share website
    </DefaultButton>
    <CustomerShareModal
      v-if="show"
      @modal:close="toggleModal(false)"
    />
  </div>
</template>
